import { PersonalDocumentContainer} from "../../containers";
import './style.scss'

function PersonalDocument() {
    return (
        <div id="personalDocument" className="bgrStyle">
            <PersonalDocumentContainer />
        </div>
    );
}
export default PersonalDocument;